<div *ngIf="player.fullscreen || (player && alwaysOn)" class="analysisControls">
  <sn-icon-button matTooltip="Screenshot Video" (click)="clip()">
    <sn-icon size="md">content_cut</sn-icon>
  </sn-icon-button>
</div>
